import React from 'react'
import { FormDisplayErrors } from '@myxplor/forms'

export const DaySessionWarning = () =>
  <FormDisplayErrors errors='By law sessions are not allowed to be longer than 12 hours' />



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/actions/update-enrolment-schedule/form/day-session-warning.jsx